"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { useState } from "react"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { extractProperty, replaceRichTextLinks } from "utils"
import { StyledTypographyWithTable } from "../Common/FaqItem"
import ReactPlayerComponent from "../Homepage/Hero/ReactPlayer"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

const StyledText = styled(StyledTypographyWithTable)<{ component: any }>`
  a {
    display: inline-block;
  }
`

const MediaContainer = styled.div`
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  margin-top: 24px;
`

type Props = {
  data: any
  blockIndex?: number
  isHomepage?: boolean
  noContainer?: boolean
}

const TitleTextAndMedia = ({
  data,
  blockIndex,
  isHomepage,
  noContainer,
}: Props) => {
  const [playing, setPlaying] = useState(false)
  const [volume, setVolume] = useState(false)
  const subTitle = extractProperty(data, "subTitle")
  const content = extractProperty(data, "content")
  const mediaUrl = extractProperty(data, "media")?.[0]?.url
  const isGray =
    isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1
  console.log(mediaUrl, "2egfwefwef")
  const renderedContent = () => {
    return (
      <OuterContainer $isGray={isGray}>
        <Typography variant="h2">{subTitle}</Typography>
        <StyledText
          variant="body1"
          component={"div"}
          dangerouslySetInnerHTML={{
            __html: replaceRichTextLinks(content)?.replace("h2", "h3"),
          }}
        />
        {mediaUrl && (
          <MediaContainer>
            <ReactPlayerComponent
              source={mediaUrl}
              playing={playing}
              setPlaying={setPlaying}
              setVolume={setVolume}
              volume={volume}
            />
          </MediaContainer>
        )}
      </OuterContainer>
    )
  }
  if (noContainer) {
    return renderedContent()
  }
  return <Container paddingMobile>{renderedContent()}</Container>
}

export default TitleTextAndMedia
